"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAminoMsgVerifyInvariant = isAminoMsgVerifyInvariant;
exports.createCrysisAminoConverters = createCrysisAminoConverters;
function isAminoMsgVerifyInvariant(msg) {
    return msg.type === "cosmos-sdk/MsgVerifyInvariant";
}
function createCrysisAminoConverters() {
    throw new Error("Not implemented");
}
